import { Check, Palette } from "lucide-react";
import { Label } from "@/components/ui/label";
import { ScrollArea } from "@/components/ui/scroll-area";
import { cn } from "@/lib/utils";
import { GradientPreview } from "./GradientPreview";

// 染色颜色选择器组件（支持多 Toning）
export interface ToningColorPickerProps {
  toningIds: string[];
  templateConfig: any;
  selectedToningColors: Record<string, string>;
  onColorSelect: (toningId: string, colorId: string) => void;
}

export function ToningColorPicker({
  toningIds,
  templateConfig,
  selectedToningColors,
  onColorSelect,
}: ToningColorPickerProps) {
  // 只过滤存在的 toning（跳过无效引用）
  const tonings =
    templateConfig?.tonings?.filter((t: any) => toningIds.includes(t.id)) || [];

  if (tonings.length === 0) {
    return null;
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Palette className="h-3.5 w-3.5 text-muted-foreground" />
        <Label className="text-xs">颜色预览</Label>
      </div>

      <ScrollArea className="max-h-[200px]">
        <div className="space-y-3 pr-3">
          {tonings.map((toning: any) => {
            // 当前选中的配色 ID（不使用 fallback，允许为空）
            const currentColorId = selectedToningColors[toning.id];

            return (
              <div key={toning.id} className="space-y-1.5">
                <div className="flex items-center gap-2">
                  <span className="text-[10px] font-medium text-muted-foreground">
                    {toning.name || toning.id}
                  </span>
                </div>
                <div className="grid grid-cols-6 gap-1">
                  {(toning.colors || []).map((colorSet: any) => {
                    const isSelected = currentColorId === colorSet.id;
                    return (
                      <div
                        key={colorSet.id}
                        className={cn(
                          "relative rounded-lg border cursor-pointer transition-all overflow-hidden",
                          isSelected
                            ? "border-primary ring-2 ring-primary/30"
                            : "border-transparent hover:border-primary/50",
                        )}
                        onClick={() => onColorSelect(toning.id, colorSet.id)}
                        title={colorSet.id}
                      >
                        {/* 使用 GradientPreview 显示渐变 */}
                        <div className="w-full h-8">
                          <GradientPreview colorSet={colorSet} />
                        </div>
                        {isSelected && (
                          <div className="absolute inset-0 flex items-center justify-center bg-black/20 rounded">
                            <Check className="h-3 w-3 text-white" />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </ScrollArea>
    </div>
  );
}
